import { Meilisearch } from 'meilisearch';

const { url = null, apiKeySearch = null } = window.MeiliSearchConfig;
const meilisearch = new Meilisearch({
    host: url,
    apiKey: apiKeySearch,
});
const geocodingIndex = meilisearch.index('geocoding');

const mapContainer = document.getElementById('offer-map');

const updateHistoryState = (zip, limit) => {
    if (!zip || !limit) {
        return window.history.pushState(null, null, window.location.pathname);
    }
    const existingSearchState = new URL(window.location).searchParams.toString();
    const newSearchState = `zip=${zip}&limit=${limit}`;
    if (existingSearchState === newSearchState) return;
    const newStateUrl = `${window.location.pathname}?${newSearchState}`;
    return window.history.pushState(newSearchState, newSearchState, newStateUrl);
};

const getLocationsByZip = async zip => {
    const result = await geocodingIndex.search(``, { filter: `zip = ${zip}` });
    return result.hits;
};

const getOffersByLocation = async (location, limit = 20) => {
    const url = `/actions/site/map/find-nearby-addresses?latitude=${location.latitude}&longitude=${location.longitude}&limit=${limit}`;
    const response = await fetch(url);
    return await response.json();
};

const getBrowserGeolocation = () =>
    new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            position => resolve(position),
            error => reject(error),
            {
                maximumAge: 5000,
                enableHighAccuracy: false,
            },
        );
    });

const updateMapForLocation = async (location, limit) => {
    const geojson = await getOffersByLocation(location, limit);
    const event = new CustomEvent('mapboxupdate', {
        detail: {
            geojson,
            location,
        },
    });
    mapContainer.dispatchEvent(event);
};

const zipInput = document.querySelector('[name="zip"]');
const resultLimitInput = document.querySelector('[name="limit"]');
const useLocationButton = document.querySelector('[name="use_location"]');
const zipErrorElement = document.getElementById('offer-map-zip-error');

let currentLocation = null;

const setZipError = message => {
    zipErrorElement.textContent = message;
    zipInput.setAttribute('aria-invalid', 'true');
    zipInput.setAttribute('aria-errormessage', 'offer-map-zip-error');
    zipInput.setCustomValidity(message);
    zipInput.reportValidity();
};
const clearZipError = () => {
    zipErrorElement.textContent = '';
    zipInput.removeAttribute('aria-invalid');
    zipInput.removeAttribute('aria-errormessage');
    zipInput.setCustomValidity('');
};

const displayZipValid = () => {
    clearZipError();
    zipInput.classList.add('is-valid');
    zipInput.classList.remove('is-invalid');
};
const displayZipInvalid = message => {
    setZipError(message);
    zipInput.classList.remove('is-valid');
    zipInput.classList.add('is-invalid');
};
const resetZipValidityDisplay = () => {
    clearZipError();
    zipInput.classList.remove('is-valid');
    zipInput.classList.remove('is-invalid');
};

const refreshByZipInput = async () => {
    const zip = zipInput.value;
    const limit = Number(resultLimitInput.value);

    if (isNaN(zip)) {
        displayZipInvalid('Bitte geben Sie eine Postleitzahl ein');
        return;
    }
    if (zip.length < 5) {
        resetZipValidityDisplay();
        return;
    }

    const results = await getLocationsByZip(zip);
    if (results.length) {
        const { lat: latitude, lng: longitude } = results[0];
        currentLocation = { latitude, longitude };
        await updateMapForLocation(currentLocation, limit);
        updateHistoryState(zip, limit);
        displayZipValid();
    } else {
        displayZipInvalid('Die eingegebene Postleitzahl existiert nicht');
    }
};

const refreshByLocationButton = async () => {
    let location;
    try {
        location = await getBrowserGeolocation();
    } catch (e) {
        console.error(e);
        const GEOLOCATION_ERROR_CODE_MESSAGES = {
            1: 'Der Zugriff auf den Standort wurde abgelehnt. Um diese Funktion zu nutzen, müssen Sie über Ihren Browser den Zugriff auf Ihren Standort gewähren.',
            2: 'Ihre Position konnte nicht ermittelt werden. Eventuell ist der Zugriff auf den Standort über das Betriebssystem deaktiviert, oder Ihr Gerät kann den Standort nicht ermittlen.',
            3: 'Ihre Position kann aktuell nicht bestimmt werden. Bitte versuchen Sie es später erneut.',
        };
        const message =
            GEOLOCATION_ERROR_CODE_MESSAGES[e.code] || 'Ein unbekannter Fehler ist aufgetreten.';
        alert(message);
        return;
    }
    const { latitude, longitude } = location.coords;
    const limit = Number(resultLimitInput.value);
    zipInput.value = '';
    resetZipValidityDisplay();
    currentLocation = { latitude, longitude };
    await updateMapForLocation(currentLocation, limit);
    updateHistoryState(null, limit);
};

const refreshByLimitSelection = async () => {
    if (!currentLocation) return;
    const zip = zipInput.value;
    const limit = Number(resultLimitInput.value);
    await updateMapForLocation(currentLocation, limit);
    updateHistoryState(zip, limit);
};

const restoreStateFromHistory = () => {
    const params = new URL(window.location).searchParams;
    zipInput.value = params.get('zip');
    resultLimitInput.value = params.get('limit');
    refreshByZipInput();
};

refreshByZipInput();

zipInput.addEventListener('input', e => refreshByZipInput());
useLocationButton.addEventListener('click', e => refreshByLocationButton());
resultLimitInput.addEventListener('change', e => refreshByLimitSelection());

window.addEventListener('popstate', e => restoreStateFromHistory());
